// Footer.js
import React from 'react';

const Footer = () => {
  const links = [
    { label: 'GitHub', href: 'https://github.com/shreyamsharma' },
    { label: 'LinkedIn', href: 'https://www.linkedin.com/in/shreyamsharma/' },
  ];

  return (
    <footer style={{
      background: '#2C1F14',
      color: 'rgba(255,255,255,0.85)',
      padding: '2.5rem 2rem',
      textAlign: 'center',
      borderTop: '1px solid rgba(255, 255, 255, 0.08)'
    }}>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
        {links.map(link => (
          <a key={link.label} href={link.href} target="_blank" rel="noopener noreferrer" style={{
            color: '#E8C4A0', textDecoration: 'none', fontWeight: 600, fontSize: '1rem'
          }}>
            {link.label}
          </a>
        ))}
      </div>
      <p style={{ margin: 0, fontSize: '0.9rem', color: 'rgba(255,255,255,0.4)' }}>
        {new Date().getFullYear()} Shreya Sharma. Built with React.
      </p>
    </footer>
  );
};

export default Footer;
